<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { onMounted, watch } from 'vue'
import { AuthActionTypes, useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth'

// Route & Router
const route = useRoute()
const router = useRouter()

// Store
const AuthStore = useAuthStore()

onMounted(() => {
  window.addEventListener('unauthorized', () => {
    AuthStore.logout() // nếu có hàm logout thì gọi
    router.push({
      name: 'auth.login',
      query: { redirect: route.path },
    })
  })
})

// Redirect nếu chưa đăng nhập
watch(
  () => AuthStore.action_type,
  (newVal) => {
    if (newVal !== AuthActionTypes.LOGINED) {
      router.push({
        name: 'auth.login',
        query: { redirect: route.path },
      })
    }
  },
  { immediate: true }
)
</script>

<template>
  <component
    v-if="route.meta.component"
    :is="route.meta.component"
  />
  <div v-else>
    <!-- fallback UI khi chưa load được component -->
    <p>Đang tải...</p>
  </div>
</template>

<style scoped>
/* tuỳ ý thêm */
</style>
